import { getActivePinia } from 'pinia';

/**
 * Composable returns a function that when called will reset all
 * registered Pinia stores by invoking their $reset() method.
 * This requires the createResetAllPlugin to be installed
 * on the Pinia instance.
 * @returns {Function} A function that resets all stores when called
 * @example
 * <script setup>
 * import { useResetAllStores } from '@/composables/useResetAllStores';
 *
 * const resetAll = useResetAllStores()
 * const handleReset = () => {
 *   resetAll()
 * }
 * </script>
 */
export function useResetAllStores() {
  return () => {
    const pinia = getActivePinia();
    if (pinia && typeof pinia.resetAll === 'function') {
      pinia.resetAll();
    }
  };
}
